import { render } from "./current-work.vue?vue&type=template&id=55f1fb0b&scoped=true&ts=true"
import script from "./current-work.vue?vue&type=script&lang=ts"
export * from "./current-work.vue?vue&type=script&lang=ts"

import "./current-work.vue?vue&type=style&index=0&id=55f1fb0b&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f1fb0b"]])

export default __exports__